import { BasicRequest } from "./basicRequest";

export class ResetPasswordVerificationRequest extends BasicRequest{

    public token! : string;

    constructor(){
        super();
    }
}